// extracted by mini-css-extract-plugin
module.exports = {"no_data":"leaderboards_no_data__21uok","current_player":"leaderboards_current_player__2k4q5","rank":"leaderboards_rank__19bth"};